// Zentraler Katalog der TanStack-Query-Keys. Ein Slug-Argument macht
// Invalidierung pro Trip trivial: `qc.invalidateQueries({ queryKey: tripKeys.all(slug) })`.

export const tripKeys = {
  all: (slug: string) => ['trip', slug] as const,
  config: (slug: string) => ['trip', slug, 'config'] as const,
  identity: (slug: string) => ['trip', slug, 'identity'] as const,
  profile: (slug: string) => ['trip', slug, 'profile'] as const,
  acts: (slug: string) => ['trip', slug, 'acts'] as const,
  votes: (slug: string) => ['trip', slug, 'votes'] as const,
  ratings: (slug: string) => ['trip', slug, 'ratings'] as const,
  actRatings: (slug: string, actId: string) => ['trip', slug, 'ratings', 'act', actId] as const,
  favorites: (slug: string) => ['trip', slug, 'favorites'] as const,
  chat: (slug: string) => ['trip', slug, 'chat'] as const,
  heatpoints: (slug: string, hours: number) => ['trip', slug, 'heatpoints', hours] as const,
  liveloc: (slug: string) => ['trip', slug, 'liveloc'] as const,
  weather: (slug: string) => ['trip', slug, 'weather'] as const,
  status: (slug: string) => ['trip', slug, 'status'] as const,
  crewMembers: (slug: string) => ['trip', slug, 'crewMembers'] as const,
  drinks: (slug: string) => ['trip', slug, 'drinks'] as const,
  bierschiss: (slug: string) => ['trip', slug, 'bierschiss'] as const,
  konq: (slug: string) => ['trip', slug, 'konq'] as const,
  expenses: (slug: string) => ['trip', slug, 'expenses'] as const,
  settlements: (slug: string) => ['trip', slug, 'settlements'] as const,
  gallery: (slug: string) => ['trip', slug, 'gallery'] as const,
  photovote: (slug: string, date?: string) => ['trip', slug, 'photovote', date ?? 'today'] as const,
  awards: (slug: string, date?: string) => ['trip', slug, 'awards', date ?? 'today'] as const,
  confessions: (slug: string) => ['trip', slug, 'confessions'] as const,
  recap: (slug: string) => ['trip', slug, 'recap'] as const,
  booklet: (slug: string) => ['trip', slug, 'booklet'] as const,
  game: (slug: string, kind: string) => ['trip', slug, 'game', kind] as const,
  tips: (slug: string) => ['trip', slug, 'tips'] as const,
  dailySummary: (slug: string, date?: string) => ['trip', slug, 'dailySummary', date ?? 'today'] as const,
  quiz: (slug: string) => ['trip', slug, 'quiz'] as const,
  myMission: (slug: string) => ['trip', slug, 'mission', 'me'] as const,
  allMissions: (slug: string) => ['trip', slug, 'mission', 'all'] as const,
  horoscope: (slug: string, date?: string) => ['trip', slug, 'horoscope', date ?? 'today'] as const,
  hangover: (slug: string, date?: string) => ['trip', slug, 'hangover', date ?? 'today'] as const,
  badges: (slug: string) => ['trip', slug, 'badges'] as const,
  highlights: (slug: string) => ['trip', slug, 'highlights'] as const,
  posts: (slug: string) => ['trip', slug, 'posts'] as const,
};

export const tripListKeys = {
  all: () => ['trips', 'list'] as const,
};

export const adminKeys = {
  identity: () => ['admin', 'identity'] as const,
  trips: () => ['admin', 'trips'] as const,
  trip: (slug: string) => ['admin', 'trip', slug] as const,
  posts: (slug: string) => ['admin', 'trip', slug, 'posts'] as const,
  users: (slug: string) => ['admin', 'trip', slug, 'users'] as const,
};
